/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type InvitePersonsToTeamInput = {
    clientMutationId?: string | null | undefined;
    orgRelayId: string;
    personIds: Array<string>;
    teamId: string;
};
export type InvitePersonsToTeamMutationVariables = {
    input: InvitePersonsToTeamInput;
};
export type InvitePersonsToTeamMutationResponse = {
    readonly invitePersonsToTeam: {
        readonly clientMutationId: string | null;
    } | null;
};
export type InvitePersonsToTeamMutation = {
    readonly response: InvitePersonsToTeamMutationResponse;
    readonly variables: InvitePersonsToTeamMutationVariables;
};



/*
mutation InvitePersonsToTeamMutation(
  $input: InvitePersonsToTeamInput!
) {
  invitePersonsToTeam(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InvitePersonsToTeamPayload",
            "kind": "LinkedField",
            "name": "invitePersonsToTeam",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "InvitePersonsToTeamMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "InvitePersonsToTeamMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "62fc3c096de554c02cbf97d3afa1b23d",
            "id": null,
            "metadata": {},
            "name": "InvitePersonsToTeamMutation",
            "operationKind": "mutation",
            "text": "mutation InvitePersonsToTeamMutation(\n  $input: InvitePersonsToTeamInput!\n) {\n  invitePersonsToTeam(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'ff844cb280f6183d0e2c561b5c62ee42';
export default node;
